/**
 * Now you might be wondering WTH this component is.
 * We used to use https://github.com/lingui/js-lingui/tree/master for translation,
 * and this lib uses the component <Trans></Trans> to marl strings as "translatable",
 * but we stopped really trying to i18ize (??) the app, and the dev stopped updating the lib, which created
 * a shittone of warnings.
 * SO, in an attempt to keep the work already done, and in the hope to one day go back to translating
 * I'm temporarly replacing the Lingui <Trans/> by a mock one.
 *
 * SIMPLY PUT: I'm keeping the <Trans/> tags to make it simpler when we decide to i18ize.
 */

interface TransProps {
    children: any;
}

const Trans = ({ children }: TransProps) => children;

export default Trans;
